const myPageBtn = document.querySelector('.header__nav__item--button')
const dropDown = document.querySelector('.dropdown__container')
const htmlEl = document.getElementsByTagName('html')
const branchContainer = document.querySelector('.branch__container')
const branchSelector = document.querySelector('.branch__selector')
const branchOpenBtn = document.querySelector('.branch__open')
const page = document.querySelector('.startpage')


const showMyAccountDropDown = (e) => {
    if (dropDown) dropDown.classList.contains('dropdown__container--open') ?
        dropDown.classList.remove('dropdown__container--open') :
        dropDown.classList.add('dropdown__container--open')
}

const hideDropDowns = (e) => {
    hideMyAccountDropdown(e)
    hideBranchSelector(e)
}

function toggleDropdown(el, cssClass) {
    const hasClass = el.classList.contains(cssClass);
    el.setAttribute('aria-hidden', hasClass);
    el.classList.toggle(cssClass)
}

function toggleBranchSelector(e) {
    toggleDropdown(branchSelector, 'branch__selector--open')
}

function hideBranchSelector(e) {
    if (!(e.target.classList.contains('branch__open') || e.target.closest(".branch__open"))) {
        const dropDownBranch = document.getElementsByClassName('branch__selector')
        if (dropDownBranch.length) dropDownBranch[0].classList.remove('branch__selector--open')
    }
}

function hideMyAccountDropdown(e) {
    if (!(e.target.classList.contains('button__mypages') || e.target.closest(".button__mypages"))) {
        const dropDown = document.getElementsByClassName('dropdown__container--open')
        if (dropDown.length) dropDown[0].classList.remove('dropdown__container--open')
    }
}

function hideDropDownsOnScroll() {
    if (dropDown) dropDown.classList.remove('dropdown__container--open')
    branchContainer ? branchContainer.classList.remove('branch__container--open') : null
    branchSelector ? branchSelector.classList.remove('branch__selector--open') : null
}

if (branchOpenBtn || myPageBtn) document.body.addEventListener('click', (e) => hideDropDowns(e))
if (branchOpenBtn) document.addEventListener('scroll', (e) => hideDropDownsOnScroll())
if (branchOpenBtn) branchOpenBtn.addEventListener('click', (e) => toggleBranchSelector(e))
if (myPageBtn) myPageBtn.addEventListener('click', (e) => showMyAccountDropDown(e))
